



































































import { createComponent } from '@vue/composition-api'
import { UploadedImage } from '../api'
export default createComponent({
  props: {
    previewImages: {
      type: Array,
      default: []
    },
    uploading: {
      default: false
    },
    error: {
      default: null
    },
    onClickRemoveImage: {
      type: Function
    },
    submit: {
      type: Function
    },
    valid: {
      type: Boolean,
      default: false
    },
    formState: {
      type: Object
    },
    submitText: {
      type: String
    },
    disableProgressiveUpload: {
      type: Boolean,
      default: false
    }
  },
  name: 'ImageUploadForm',
  setup (props, context) {
    return {
      images: [],
      onChange: function (e: InputEvent) {
        context.emit('input', (e.target as HTMLInputElement).files)
      },
      onSubmit () {
        if (props.valid && typeof props.submit === 'function') {
          props.submit()
        }
      },
      removeImage: (image: UploadedImage) => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        props.onClickRemoveImage!(image)
      }
    }
  }
})
